// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1EGqx","innerContainer":"styles_innerContainer__3QDzZ","name":"styles_name__1a1wH","logout":"styles_logout__1sNDn","smpc":"styles_smpc__29qRW"};